<template>
    <article class="post-card blank">
        <div class="post-card-media">
            <div class="blank-image" />
            <div class="post-category">
                <div class="blank-tag" />
            </div>
        </div>

        <div class="post-card--title">
            <div class="blank-title bg-light01" />
        </div>
    </article>
</template>

<script setup lang="ts"></script>
